'use client'

import { useEffect } from 'react'
import { revealInScroller } from '@/lib/keyboard-focus-in-view'

/**
 * FRIDGE-1582 — when keyboard focus lands on an element that is partly
 * outside a horizontal row (a homepage rail, the product page's quick
 * comparison, a chip row), the row scrolls so the whole element shows
 * (lib/keyboard-focus-in-view.ts). Keyboard focus only (:focus-visible): a
 * tap or click leaves the row where the shopper put it. It runs at once, so
 * the row is already in place when the focus scroll would run, and again one
 * frame later, after the browser's own focus scroll and any snap that follows
 * it, while the element still has focus.
 */
export default function KeyboardFocusInView() {
  useEffect(() => {
    let frame = 0
    const onFocusIn = (e: FocusEvent) => {
      const el = e.target
      if (!(el instanceof Element)) return
      let keyboard = true
      try { keyboard = el.matches(':focus-visible') } catch { keyboard = true }
      if (!keyboard) return
      revealInScroller(el)
      cancelAnimationFrame(frame)
      frame = requestAnimationFrame(() => {
        if (document.activeElement === el) revealInScroller(el)
      })
    }
    document.addEventListener('focusin', onFocusIn)
    return () => {
      document.removeEventListener('focusin', onFocusIn)
      cancelAnimationFrame(frame)
    }
  }, [])
  return null
}
